import axios, { getEnv } from '../../../services/api';


export const ManutencaoService = {
    findAll: async (params, body = {}) => {
        try {
            const response = await axios.post(`${await getEnv('REACT_APP_URL_SERVICE')}/v1/manutencao/consultar`, body, {
                params,
            });
            return response.data;
        } catch (error) {
            console.log(error);
            throw error;
        }
    },

    find: async (id) => {
        try {
            const response = await axios.get(`${await getEnv('REACT_APP_URL_SERVICE')}/v1/manutencao/${id}`)
            return response.data;
        } catch (error) {
            return error;
        }
    },

    findLastAdmin: async () => {
        try {
            const response = await axios.get(`${await getEnv('REACT_APP_URL_SERVICE')}/v1/manutencao/adm`)
            return response.data;
        } catch (error) {
            return error;
        }
    },

    manutencaoAdmin: async () => {
        try {
            const response = await axios.get(`${await getEnv('REACT_APP_URL_SERVICE')}/v1/manutencao/adm`)
            return response.data;
        } catch (error) {
            throw error;
        }
    },


    save: async (body) => {
        const response = await axios.post(`${await getEnv('REACT_APP_URL_SERVICE')}/v1/manutencao`, body);
        return response.data;

    },

    update: async (body) => {
        return await axios.put(`${await getEnv('REACT_APP_URL_SERVICE')}/v1/manutencao`, body);
    },

    changeStatus: async (id) => {
        const params = {id};
        try {
            return await axios.put(`${await getEnv('REACT_APP_URL_SERVICE')}/v1/manutencao/status`, {}, {params});
        } catch (error) {
            throw error;
        }
    },
    delete: async (id) => {
        return await axios.delete(`${await getEnv('REACT_APP_URL_SERVICE')}/v1/manutencao/${id}`);

    },
};
